import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "@sentry/react";

import { App } from "@/app/app";
import { Error } from "@/pages/Error";
import { withProviders } from "@/app/providers/withProviders";

const root = createRoot(document.getElementById("root"));

const SentryErrorFallback = ({ error }) => <Error error={error} />;

const Content = withProviders(() => (
  <StrictMode>
    <BrowserRouter>
      <ErrorBoundary fallback={SentryErrorFallback}>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </StrictMode>
));

root.render(<Content />);
